var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    [
      _c("modal-pop", {
        attrs: {
          opened: _vm.isNoPopupOpen,
          modalHeader: true,
          modalFooter: true,
          btnClose: true,
          titleCenter: true,
          title: "MPSH-01-01-00-09"
        },
        on: {
          "update:opened": function($event) {
            _vm.isNoPopupOpen = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [
                _c(
                  "strong",
                  { staticClass: "info-question mtop-12 btm-border" },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$getGlobalDateFmt(_vm.today)) +
                        " " +
                        _vm._s(_vm.$t("MPSH-01-01-02-02")) +
                        " "
                    )
                  ]
                ),
                _c("div", { staticClass: "desc mtop-12 mbtm-12" }, [
                  _vm._v(" " + _vm._s(_vm.$t("MPSH-01-01-02-03")) + " ")
                ])
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "button",
                  {
                    staticClass: "btn bottom negative",
                    on: {
                      click: function() {
                        _vm.isNoPopupOpen = false
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("MPSH-01-01-00-03")) + " ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn bottom positive",
                    on: {
                      click: function() {
                        _vm.$router.push({ name: "pushNotiStup" })
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("MPSH-01-01-00-08")) + " ")]
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }